exports = module.exports = require("../../../../../../../../web-hosted/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".PiecesView__TopChip__3h0vD {\n  background-color: gray;\n  color: #fff;\n  padding: 3px 16px;\n  border-radius: 20px;\n  margin-bottom: 6px;\n  opacity: 0.5;\n  -webkit-transition: all 0.1s ease-in;\n  -o-transition: all 0.1s ease-in;\n  transition: all 0.1s ease-in;\n}\n\n.PiecesView__TopChip__3h0vD:hover {\n  opacity: 1;\n}\n\n.PiecesView__BottomChip__2WHc7 {\n  background-color: gray;\n  color: #fff;\n  padding: 3px 16px;\n  border-radius: 20px;\n  margin-bottom: 6px;\n  opacity: 0.5;\n  -webkit-transition: all 0.1s ease-in;\n  -o-transition: all 0.1s ease-in;\n  transition: all 0.1s ease-in;\n}\n\n.PiecesView__BottomChip__2WHc7:hover {\n  opacity: 1;\n}\n", ""]);

// exports
exports.locals = {
	"TopChip": "PiecesView__TopChip__3h0vD",
	"BottomChip": "PiecesView__BottomChip__2WHc7"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../shared-components/src/containers/Mainpage/containers/SingleTaskPage/CollectionView/PiecesView/PiecesView.css
// module id = 682
// module chunks = 0